module.exports = __webpack_public_path__ + "img/mb-way.2ffad2a.svg";